module.exports = __webpack_public_path__ + "img/lindsay-mathyssen.f231d009.png";